import { render, staticRenderFns } from "./FastQuotationForm.vue?vue&type=template&id=52849d2e"
import script from "./FastQuotationForm.vue?vue&type=script&lang=js"
export * from "./FastQuotationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports